import React from 'react'
import styled from 'styled-components'

import WorldMap from '@/assets/images/map.png'

const Container = styled.div`
  background-image: url(${WorldMap});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center center;
`
const ColumnContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

type TriColumnContainerProps = {
  title: string
}

// Display a title prop and a container consisting of 1-3 TriColumn components.
export const TriColumnContainer: React.FC<TriColumnContainerProps> = ({ children, title }) => {
  return (
    <Container>
      <h5>{title}</h5>
      <ColumnContainer>{children}</ColumnContainer>
    </Container>
  )
}
